import { FileSystemUploadResult } from "expo-file-system";
import { ErrorsWrapper } from "./ErrorsWrapper";

export class ErrorFileUploadResponseWrapper extends Error implements ErrorsWrapper<string[]>{

  private readonly response: FileSystemUploadResult;

  constructor(response: FileSystemUploadResult) {
    super();
    this.response = response;
  }

  async getErrorMessages(): Promise<string[]> {
    return new Promise<string[]>((resolve) => {
      try {
        (typeof this.response.body === 'string') ? resolve([this.response.body] as any) : resolve(this.response.body);
      }
      catch (Error) {
        resolve([] as any);
      }
    })
  }
}
